var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BookModelCollection } from '../BookModelCollection';
import uniq from "lodash/uniq";
var CourseTimespansQuantityStepModelCollection = /** @class */ (function (_super) {
    __extends(CourseTimespansQuantityStepModelCollection, _super);
    function CourseTimespansQuantityStepModelCollection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CourseTimespansQuantityStepModelCollection.prototype.generateStepRange = function (_a) {
        var min_quantity = _a.min_quantity, max_quantity = _a.max_quantity;
        return uniq(this.all().reduce(function (stepRanges, step) {
            return stepRanges.concat.apply(stepRanges, step.getStepRange({ max_quantity: max_quantity }));
        }, []))
            .filter(function (value) { return value > 0 && min_quantity <= value; })
            .sort(function (x, y) { return x - y; });
    };
    return CourseTimespansQuantityStepModelCollection;
}(BookModelCollection));
export { CourseTimespansQuantityStepModelCollection };
